export default __webpack_public_path__ + "static/media/client-12.574e2214.png";